import React, { useEffect } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet";

const UKRAINE_CENTER = [49.4, 31.17];

function PlaceMap({ lat, lon, zoom, onPointerChange = undefined }) {
  useEffect(() => {}, [lat, lon]);

  const hasCoords =
    lat != null && lon != null && String(lat) !== "" && String(lon) !== "";
  const center = hasCoords ? [Number(lat), Number(lon)] : UKRAINE_CENTER;
  const effectiveZoom = zoom !== undefined ? zoom : hasCoords ? 18 : 6;

  const handleClick = (e) => {
    if (onPointerChange !== undefined) {
      onPointerChange(e);
    }
  };

  const MapClickEvents = () => {
    useMapEvents({
      click: handleClick,
    });
  };

  const markerIcon = new L.Icon({
    iconUrl: require("../../images/pointer.png"),
    iconSize: [44, 44],
    iconAnchor: [22, 44],
    popupAnchor: [0, -38],
  });

  return (
    <div className="w-full h-full">
      <MapContainer
        center={center}
        zoom={effectiveZoom}
        style={{
          height: "100%",
          width: "100%",
          background: "content-box",
          cursor: "auto",
        }}
        scrollWheelZoom={true}
      >
        <MapClickEvents />
        <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {hasCoords && (
          <Marker position={[Number(lat), Number(lon)]} icon={markerIcon} />
        )}
      </MapContainer>
    </div>
  );
}

export default PlaceMap;
